// assets/free-shipping.js
(function () {
  var FS_DEBUG = false;

  function fsDebug(label, data) {
    if (!FS_DEBUG) return;
    try {
      console.log('[FS DEBUG]', label, data || '');
    } catch (e) {}
  }

  // --- helpers ---------------------------------------------------------------
  // Format "minor units" using shop.money_format-like tokens.
  // - Non-zero decimal currencies (USD, HKD, ...):   minor = cents → display cents/100
  // - Zero-decimal currencies   (JPY, VND, ...):     minor = units → display integer
  function formatMoney(minor, moneyFormat, isZeroDecimal) {
    var amount = Number(minor || 0);

    var value = isZeroDecimal
      ? Math.round(amount)
      : amount / 100;

    var amountWithDot = isZeroDecimal
      ? String(Math.round(value))
      : value.toFixed(2);

    var amountNoDecimals = String(Math.round(value));

    // Shopify token: {{amount_with_comma_separator}}
    // Example: 1234.56 -> 1.234,56
    var amountWithCommaSeparator = amountWithDot
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Shopify token: {{amount}}
    // Example: 1234.56 -> 1,234.56
    var amountWithSeparator = amountWithDot
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amountWithSeparator)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(
        /\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
        amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      );
  }

  // Ensure .fs-wrap has .fs-note and .fs-bar/__fill
  function ensureStructure($wrap) {
    if (!$wrap.querySelector('.fs-note')) {
      var note = document.createElement('div');
      note.className = 'fs-note';
      note.setAttribute('aria-live', 'polite');
      $wrap.insertAdjacentElement('afterbegin', note);
    }

    if (!$wrap.querySelector('.fs-bar')) {
      var bar = document.createElement('div');
      bar.className = 'fs-bar';
      var fill = document.createElement('span');
      fill.className = 'fs-bar__fill';
      bar.appendChild(fill);
      $wrap.appendChild(bar);
    }
  }

  // Render a single widget (all values are "minor units")
  function renderFS($wrap, thresholdMinor, subtotalMinor, moneyFormat, isZeroDecimal) {
    ensureStructure($wrap);

    if (!thresholdMinor || thresholdMinor <= 0) {
      $wrap.hidden = true; // hide if not configured

      fsDebug('renderFS hidden', {
        thresholdMinor: thresholdMinor,
        subtotalMinor: subtotalMinor
      });

      return;
    }

    $wrap.hidden = false;

    var note = $wrap.querySelector('.fs-note');
    var fill = $wrap.querySelector('.fs-bar__fill');

    var subtotal = Math.max(0, Number(subtotalMinor || 0));
    var pct = Math.max(0, Math.min(100, Math.floor((subtotal / thresholdMinor) * 100)));
    var remain = Math.max(0, thresholdMinor - subtotal);

    fsDebug('renderFS', {
      thresholdMinor: thresholdMinor,
      subtotalMinor: subtotalMinor,
      subtotal: subtotal,
      remain: remain,
      pct: pct,
      reached: subtotal >= thresholdMinor,
      moneyFormat: moneyFormat,
      isZeroDecimal: isZeroDecimal
    });

    if (fill) fill.style.width = pct + '%';

    var textReached = $wrap.getAttribute('data-fs-text-reached') || 'You have reached Free Shipping!';
    var textTemplate = $wrap.getAttribute('data-fs-text-template') || 'Spend {{ remaining_amount }} more to enjoy Free Shipping!';

    if (note) {
      if (subtotal >= thresholdMinor) {
        note.textContent = textReached;

        fsDebug('renderFS reached', {
          note: note.textContent
        });
      } else {
        var amountHtml = '<span>' + formatMoney(remain, moneyFormat, isZeroDecimal) + '</span>';

        // support both {{ remaining_amount }} and {{count}}
        var out = textTemplate;
        out = out.replace('{{ remaining_amount }}', amountHtml);
        out = out.replace('{{count}}', amountHtml);

        note.innerHTML = out;

        fsDebug('renderFS remaining', {
          amountHtml: amountHtml,
          note: note.innerHTML
        });
      }
    }
  }

  // Fetch latest cart.json
  async function fetchCart() {
    fsDebug('fetchCart start');

    const res = await fetch('/cart.js', { credentials: 'same-origin' });

    fsDebug('fetchCart response', {
      ok: res.ok,
      status: res.status
    });

    if (!res.ok) throw new Error('cart.js failed');

    var json = await res.json();

    fsDebug('fetchCart json', {
      item_count: json.item_count,
      total_price: json.total_price,
      currency: json.currency,
      items: (json.items || []).map(function(item) {
        return {
          title: item.title,
          quantity: item.quantity,
          final_line_price: item.final_line_price
        };
      })
    });

    return json;
  }

  function parseThresholdToMinor(value, isZeroDecimal) {
    if (value === null || value === undefined) return 0;

    var s = String(value)
      .replace(/HK\$/g, '')
      .replace(/NT\$/g, '')
      .replace(/SG\$/g, '')
      .replace(/[$€£¥]/g, '')
      .trim()
      .replace(/,/g, '.');

    if (!s) return 0;

    var n = Number(s);
    if (!isFinite(n) || n <= 0) return 0;

    return isZeroDecimal ? Math.round(n) : Math.round(n * 100);
  }

  function getCurrencyThresholdMinor($wrap, cartJson, fallbackThresholdMinor, isZeroDecimal) {
    var currency = '';

    if (cartJson && cartJson.currency) {
      currency = String(cartJson.currency).toUpperCase();
    }

    if (!currency) {
      currency = String($wrap.getAttribute('data-fs-currency') || '').toUpperCase();
    }

    var rawJson = $wrap.getAttribute('data-fs-thresholds-json') || '';

    fsDebug('getCurrencyThresholdMinor start', {
      currency: currency,
      fallbackThresholdMinor: fallbackThresholdMinor,
      isZeroDecimal: isZeroDecimal,
      rawJson: rawJson,
      cartCurrency: cartJson && cartJson.currency,
      wrapCurrency: $wrap.getAttribute('data-fs-currency')
    });

    if (!rawJson || !currency) {
      fsDebug('getCurrencyThresholdMinor fallback no json/currency', {
        currency: currency,
        rawJson: rawJson,
        fallbackThresholdMinor: fallbackThresholdMinor
      });

      return fallbackThresholdMinor;
    }

    try {
      var thresholds = JSON.parse(rawJson);

      fsDebug('getCurrencyThresholdMinor parsed json', thresholds);

      if (
        thresholds &&
        thresholds[currency] !== undefined &&
        thresholds[currency] !== null &&
        thresholds[currency] !== ''
      ) {
        var parsedThresholdMinor = parseThresholdToMinor(thresholds[currency], isZeroDecimal);

        fsDebug('getCurrencyThresholdMinor override used', {
          currency: currency,
          rawValue: thresholds[currency],
          parsedThresholdMinor: parsedThresholdMinor
        });

        return parsedThresholdMinor;
      }
    } catch (e) {
      fsDebug('getCurrencyThresholdMinor json parse error', {
        rawJson: rawJson,
        error: e && e.message
      });

      return fallbackThresholdMinor;
    }

    fsDebug('getCurrencyThresholdMinor fallback no currency match', {
      currency: currency,
      fallbackThresholdMinor: fallbackThresholdMinor
    });

    return fallbackThresholdMinor;
  }

  // Process a single .fs-wrap
  function processWrap($wrap, cartJson) {
    var fallbackThresholdMinor = Number($wrap.getAttribute('data-fs-threshold') || 0);
    var moneyFormat = $wrap.getAttribute('data-fs-money-format') || '{{amount}}';
    var isZeroDecimal = ($wrap.getAttribute('data-fs-zero-decimal') || 'false') === 'true';

    var thresholdMinor = getCurrencyThresholdMinor($wrap, cartJson, fallbackThresholdMinor, isZeroDecimal);

    var subtotalAttr = Number($wrap.getAttribute('data-fs-subtotal') || 0);
    var subtotalMinor = (cartJson && typeof cartJson.total_price === 'number')
      ? cartJson.total_price
      : subtotalAttr;

    fsDebug('processWrap', {
      wrap: $wrap,
      fallbackThresholdMinor: fallbackThresholdMinor,
      thresholdMinor: thresholdMinor,
      subtotalAttr: subtotalAttr,
      subtotalMinor: subtotalMinor,
      cartJsonTotalPrice: cartJson && cartJson.total_price,
      cartJsonCurrency: cartJson && cartJson.currency,
      dataFsCurrency: $wrap.getAttribute('data-fs-currency'),
      dataFsThresholdsJson: $wrap.getAttribute('data-fs-thresholds-json'),
      moneyFormat: moneyFormat,
      isZeroDecimal: isZeroDecimal,
      noteBefore: $wrap.querySelector('.fs-note') && $wrap.querySelector('.fs-note').innerHTML
    });

    renderFS($wrap, thresholdMinor, subtotalMinor, moneyFormat, isZeroDecimal);
  }

  function renderAllWraps(cartJson) {
    var wraps = document.querySelectorAll('.fs-wrap');

    fsDebug('renderAllWraps', {
      wrapsCount: wraps.length,
      total_price: cartJson && cartJson.total_price,
      currency: cartJson && cartJson.currency
    });

    wraps.forEach(function($wrap) {
      processWrap($wrap, cartJson);
    });
  }

  var _lastCart = null;

  async function refreshAll(cartJson) {
    var wraps = document.querySelectorAll('.fs-wrap');

    fsDebug('refreshAll start', {
      wrapsCount: wraps.length,
      hasIncomingCartJson: !!cartJson,
      incomingTotalPrice: cartJson && cartJson.total_price,
      incomingCurrency: cartJson && cartJson.currency
    });

    if (!wraps.length) return;

    if (!cartJson) {
      try {
        cartJson = await fetchCart();
      } catch (e) {
        fsDebug('refreshAll fetchCart error', {
          error: e && e.message
        });
        return;
      }
    }

    _lastCart = cartJson;

    fsDebug('refreshAll render', {
      total_price: cartJson.total_price,
      currency: cartJson.currency,
      item_count: cartJson.item_count
    });

    renderAllWraps(cartJson);
  }

  var _rfTimer = null;
  var _pendingCart = undefined;

  function refreshSoon(cartJson) {
    fsDebug('refreshSoon called', {
      hasCartJson: !!cartJson,
      total_price: cartJson && cartJson.total_price,
      currency: cartJson && cartJson.currency
    });

    if (cartJson) _pendingCart = cartJson;
    clearTimeout(_rfTimer);

    _rfTimer = setTimeout(function() {
      var cart = _pendingCart;
      _pendingCart = undefined;

      fsDebug('refreshSoon timer fired', {
        hasPendingCart: !!cart,
        total_price: cart && cart.total_price,
        currency: cart && cart.currency
      });

      refreshAll(cart);
    }, 300);
  }

  // --- event wiring ----------------------------------------------------------
  var _initialised = false;

  async function initialRefresh() {
    if (_initialised) return;

    _initialised = true;

    fsDebug('initialRefresh');

    await refreshAll();
  }

  document.addEventListener('DOMContentLoaded', initialRefresh);

  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      fsDebug('pageshow persisted');

      _initialised = false;
      initialRefresh();
    }
  });

  document.addEventListener('cart:updated', function(event) {
    fsDebug('event cart:updated', {
      detail: event && event.detail
    });

    refreshSoon();
  });

  // Patch fetch: read cart data directly from response instead of re-fetching
  (function patchFetch() {
    var _fetch = window.fetch;
    var reCart = /\/cart(\/add|\/change|\/update|\/remove|\/clear)(\.js)?(\?|$)/;

    window.fetch = function() {
      var args = arguments;

      return _fetch.apply(this, args).then(function(res) {
        try {
          var url = (args[0] && args[0].toString()) || '';

          if (reCart.test(url)) {
            fsDebug('fetch cart request detected', {
              url: url
            });

            res.clone().json().then(function(data) {
              fsDebug('fetch cart response json', {
                url: url,
                item_count: data && data.item_count,
                total_price: data && data.total_price,
                currency: data && data.currency,
                hasItems: !!(data && data.items)
              });

              if (data && data.items && typeof data.total_price === 'number') {
                refreshSoon(data);
              } else {
                refreshSoon();
              }
            }).catch(function(e) {
              fsDebug('fetch cart response json error', {
                url: url,
                error: e && e.message
              });

              refreshSoon();
            });
          }
        } catch (e) {
          fsDebug('fetch patch error', {
            error: e && e.message
          });
        }

        return res;
      });
    };
  })();

  // Patch XHR: themes using XMLHttpRequest
  (function patchXHR() {
    var Open = XMLHttpRequest.prototype.open;
    var Send = XMLHttpRequest.prototype.send;
    var re = /\/cart(\/add|\/change|\/update|\/remove|\/clear)(\.js)?(\?|$)/;

    XMLHttpRequest.prototype.open = function(method, url) {
      this.__isCartReq = false;

      try {
        var u = (url && url.toString()) || '';
        this.__isCartReq = re.test(u) || (typeof url === 'string' && url.indexOf('/cart') === 0);

        if (this.__isCartReq) {
          fsDebug('xhr cart request detected', {
            method: method,
            url: u
          });
        }
      } catch (e) {}

      return Open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function() {
      if (this.__isCartReq) {
        this.addEventListener('loadend', function() {
          try {
            var data = JSON.parse(this.responseText);

            fsDebug('xhr cart response json', {
              item_count: data && data.item_count,
              total_price: data && data.total_price,
              currency: data && data.currency,
              hasItems: !!(data && data.items)
            });

            if (data && data.items && typeof data.total_price === 'number') {
              refreshSoon(data);
              return;
            }
          } catch (e) {
            fsDebug('xhr cart response parse error', {
              error: e && e.message
            });
          }

          refreshSoon();
        });
      }

      return Send.apply(this, arguments);
    };
  })();

  // Listen to quantity/remove controls (cart page & drawer)
  function bindCartUiListeners() {
    var root = document;
    var qtySelectors = [
      'input[name="updates[]"]',
      'input[name="updates"]',
      '.quantity__input',
      '.cart-quantity-input',
      '.cart-item__quantity input'
    ].join(',');

    // Quantity inputs
    root.addEventListener('change', function(e) {
      if (e.target && e.target.matches(qtySelectors)) {
        fsDebug('quantity input change', {
          value: e.target.value,
          inputId: e.target.id,
          inputName: e.target.getAttribute('name'),
          inputIndex: e.target.dataset && e.target.dataset.index
        });

        refreshSoon();
      }
    });

    // Plus/minus buttons
    root.addEventListener('click', function(e) {
      var el = e.target;
      if (!el) return;

      if (el.closest && (el.closest('.quantity__button') || el.closest('[data-quantity-button]'))) {
        var btn = el.closest('.quantity__button') || el.closest('[data-quantity-button]');
        var qtyWrap = btn.closest('quantity-input') || btn.closest('.quantity') || btn.parentElement;
        var input = qtyWrap ? qtyWrap.querySelector('input') : null;

        fsDebug('quantity button click', {
          buttonName: btn.getAttribute('name'),
          inputValueAtClick: input && input.value,
          inputId: input && input.id,
          inputName: input && input.getAttribute('name'),
          inputIndex: input && input.dataset && input.dataset.index
        });

        refreshSoon();

        setTimeout(function() {
          fsDebug('quantity button after 700ms force refresh', {
            inputValue: input && input.value
          });

          refreshAll();
        }, 700);

        setTimeout(function() {
          fsDebug('quantity button after 1200ms force refresh', {
            inputValue: input && input.value
          });

          refreshAll();
        }, 1200);
      }
    });

    // Remove buttons/links
    root.addEventListener('click', function(e) {
      var t = e.target;
      if (!t) return;

      var isRemove =
        (t.matches && (
          t.matches('[data-cart-remove]') ||
          t.matches('[data-remove]') ||
          t.matches('.cart-remove')
        )) ||
        (t.closest && (
          t.closest('[data-cart-remove]') ||
          t.closest('[data-remove]') ||
          t.closest('.cart-remove')
        ));

      // Anchor patterns: /cart/remove, or /cart/change?quantity=0
      var a = t.closest && t.closest('a[href]');

      if (!isRemove && a) {
        var href = a.getAttribute('href') || '';

        if (/\/cart\/remove(\?|$)/.test(href) || /\/cart\/change(\?|$)/.test(href)) {
          isRemove = true;
        }
      }

      if (isRemove) {
        fsDebug('remove button/link click');

        refreshSoon();
      }
    });

    // Cart forms
    var forms = document.querySelectorAll('form[action="/cart"]');

    forms.forEach(function(f) {
      f.addEventListener('submit', function() {
        fsDebug('cart form submit');

        refreshSoon();
      });
    });
  }

  bindCartUiListeners();

  // Observe DOM for re-inserted .fs-wrap
  try {
    var mo = new MutationObserver(function(mutations) {
      var newWraps = [];

      mutations.forEach(function(m) {
        Array.from(m.addedNodes || []).forEach(function(n) {
          if (!n || n.nodeType !== 1) return;

          if (n.matches && n.matches('.fs-wrap')) {
            newWraps.push(n);
          }

          if (n.querySelectorAll) {
            n.querySelectorAll('.fs-wrap').forEach(function(w) {
              newWraps.push(w);
            });
          }
        });
      });

      if (!newWraps.length) return;

      fsDebug('mutation new fs-wraps', {
        count: newWraps.length,
        hasLastCart: !!_lastCart,
        lastCartTotalPrice: _lastCart && _lastCart.total_price,
        lastCartCurrency: _lastCart && _lastCart.currency
      });

      if (_lastCart) {
        newWraps.forEach(function($w) {
          processWrap($w, _lastCart);
        });
      } else {
        refreshSoon();
      }
    });

    mo.observe(document.body, {
      childList: true,
      subtree: true
    });
  } catch (e) {
    fsDebug('mutation observer error', {
      error: e && e.message
    });
  }

  // Optional: catch Shopify section lifecycle events that may re-render drawer
  document.addEventListener('shopify:section:load', function(event) {
    fsDebug('event shopify:section:load', {
      target: event && event.target
    });

    refreshSoon();
  });

  document.addEventListener('shopify:section:reorder', function(event) {
    fsDebug('event shopify:section:reorder', {
      target: event && event.target
    });

    refreshSoon();
  });

  document.addEventListener('shopify:section:select', function(event) {
    fsDebug('event shopify:section:select', {
      target: event && event.target
    });

    refreshSoon();
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    fsDebug('event shopify:section:deselect', {
      target: event && event.target
    });

    refreshSoon();
  });
})();
